// extracted by mini-css-extract-plugin
module.exports = {"terms":"wap_terms__MBNzZ","main":"wap_main__gQELM"};